// Identidad del contenido recuperable; los metadatos de presentación/resolución no son una intención nueva.
export function conflictSnapshotContent(record) {
    const ignored = new Set(['id', 'key', 'conflictUuid', 'timestamp', 'status', 'resolution']);
    return JSON.stringify(Object.fromEntries(Object.keys(record).filter(key => !ignored.has(key)).sort().map(key => [key, record[key]])));
}

export const isResolvedConflict = record => ['resolved_discarded', 'resolved_reapplied'].includes(record?.status);
